module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_4.5cd09e79.png";